import type {
  HandoverLogEntry,
  HandoverOverview,
  HandoverRequest,
  HandoverResult,
} from '@testflow/shared';
import { request } from './api.js';

// #195 Weitergabe im Fachbereich — Client der Endpunkte aus routes/handover.ts.
const base = (p: string) => `/v1/projects/${p}`;

export const handoverApi = {
  /** Meine weitergebbaren Testfälle samt Zielen und die Kollegen mit ihren übernehmbaren Einträgen. */
  overview: (p: string, planId: string) =>
    request<HandoverOverview>(`${base(p)}/plans/${planId}/handover`),
  /** Abgeben (`give`) oder Übernehmen (`take`); Teilerfolg steht in `skipped`. */
  apply: (p: string, planId: string, body: HandoverRequest) =>
    request<HandoverResult>(`${base(p)}/plans/${planId}/handover`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  /** Wirksame letzte Weitergabe je Testfall (Plan-Detail, Task 7). */
  log: (p: string, planId: string) =>
    request<HandoverLogEntry[]>(`${base(p)}/plans/${planId}/handovers`),
};
